import { useEffect } from "react";
import { useQuery } from "react-query";
import { ReservationService } from "../../services/ReservationService";
import { Skeleton, Table, TableColumnsType } from "antd";
import { mdlCustomer } from "../../models/domain/Customer";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { mdlReservationDetailRequest } from "../../models/service-models/reservation/ReservationDetailRequest";
import {mdlReservation} from "../../models/domain/Reservation";

export type ExpandableCustomerListProps = {
    reservation?: mdlReservation;
    isExpanded?: boolean;
}

export function ExpandableCustomerList(props: ExpandableCustomerListProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (props.isExpanded && props.reservation) {
            refetch();
        }
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getReservationDetail", props.reservation],
        () => {
            if (props.reservation) {
                var request: mdlReservationDetailRequest = { reservationId: props.reservation.reservationId!,agencyId:props.reservation.agencyId!,paxId : props.reservation.paximumId! };
                return ReservationService.Detail(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: false,
            cacheTime: 0,
            staleTime: 0
        }
    );

    const expandColumns: TableColumnsType<mdlCustomer> = [
        {
            title: "Customer Details",
            children: [
                { title: t("resTable.title"), dataIndex: 'title', key: 'title' },
                { title: t("resTable.name"), dataIndex: 'name', key: 'name' },
                { title: t("resTable.nationality"), dataIndex: 'nationality', key: 'nationality' },
                {
                    title: t("resTable.birthDate"), key: 'birthDate',
                    render: (e: mdlCustomer) => {
                        return dayjs(e.birthDate).format("DD-MM-YYYY")
                    }
                },
                { title: t("resTable.age"), dataIndex: 'age', key: 'age' },
                { title: t("resTable.departureYon1"), dataIndex: 'departureYon1', key: 'departureYon1' },
                { title: t("resTable.arrivalYon1"), dataIndex: 'arrivalYon1', key: 'arrivalYon1' },
                {
                    title: t("resTable.departureTime"), key: 'departureTime',
                    render: (e: mdlCustomer) => {
                        return dayjs(e.departureTime).format("HH:mm")
                    }
                },
            ]
        }
    ];

    return (
        <>
            {
                isLoading
                &&
                <Skeleton active />
            }
            {
                data
                &&
                <Table<mdlCustomer>
                    columns={expandColumns}
                    dataSource={data!.body!.reservation!.customers!.map((customer: mdlCustomer, index: number) => ({ ...customer, key: index }))}
                    pagination={false}
                />
            }
        </>
    )
}